import React from 'react';
import { API_PLAN_TO_UI } from './promoUtils.js';

const PLAN_CARD_META = {
  BASIC: {
    cardClass: 'basic',
    badgeLabel: 'BASIC',
    subtitle: '3 darmowe promowania',
    popular: false,
  },
  STANDARD: {
    cardClass: 'standard',
    badgeLabel: 'Standard',
    subtitle: 'Najbardziej popularny',
    popular: true,
  },
  VISIBILITY_PLUS: {
    cardClass: 'medium',
    badgeLabel: 'Visibility+',
    subtitle: '\u00A0',
    popular: false,
  },
  PREMIUM: {
    cardClass: 'premium',
    badgeLabel: 'Premium',
    subtitle: '\u00A0',
    popular: false,
  },
};

const FALLBACK_PLANS = [
  {
    planType: 'BASIC',
    displayName: 'Basic',
    pricePln: 0,
    durationDays: 7,
    uiDescription: 'Wyróżnienie w danej kategorii przez 7 dni.',
  },
  {
    planType: 'STANDARD',
    displayName: 'Standard',
    pricePln: 9,
    durationDays: 14,
    uiDescription: 'Wyróżnienie w danej kategorii przez 14 dni + automatyczne odświeżanie',
  },
  {
    planType: 'VISIBILITY_PLUS',
    displayName: 'Visibility+',
    pricePln: 19,
    durationDays: 21,
    uiDescription: 'Wyświetlanie na stronie głównej w zakładce „Polecane” przez 21 dni.',
  },
  {
    planType: 'PREMIUM',
    displayName: 'Premium',
    pricePln: 29,
    durationDays: 30,
    uiDescription: 'Wyświetlanie w kategorii „Polecane” przez 30 dni, wyróżnienie w danej kategorii przez 30 dni + odświeżanie co 5 dni.',
  },
];

export const mapApiPlansToCards = (apiPlans) => {
  const source = Array.isArray(apiPlans) && apiPlans.length > 0 ? apiPlans : FALLBACK_PLANS;

  return source.map((plan) => {
    const meta = PLAN_CARD_META[plan.planType] || {
      cardClass: 'basic',
      badgeLabel: plan.displayName,
      subtitle: '\u00A0',
      popular: false,
    };

    return {
      id: API_PLAN_TO_UI[plan.planType] || plan.displayName,
      cardClass: meta.cardClass,
      badgeLabel: meta.badgeLabel,
      title: plan.displayName,
      subtitle: meta.subtitle,
      price: Number(plan.pricePln || 0),
      description: plan.uiDescription || plan.description || '',
      popular: meta.popular,
    };
  });
};

export const renderPlanDescription = (description) => {
  if (!description) {
    return null;
  }

  const parts = String(description).split(/(\d+)/);
  return parts.map((part, index) => {
    if (/^\d+$/.test(part)) {
      return <span key={`${part}-${index}`} className="highlight">{part}</span>;
    }
    return part;
  });
};
